import React from 'react';
import { GiCompass, GiDiamondHard, GiStabbedNote } from 'react-icons/gi';
import {
  AiFillInstagram,
  AiFillFacebook,
  AiFillPhone,
} from 'react-icons/ai';
import { SiTiktok } from 'react-icons/si';

export const links = [
  {
    id: 1,
    text: 'home',
    url: '/',
  },
  {
    id: 2,
    text: 'about',
    url: '/about',
  },
  {
    id: 3,
    text: 'products',
    url: '/products',
  },
];

export const socialLinks = [
  {
    id: 1,
    icon: <AiFillPhone className='phone' color='var(--clr-primary-5)' fontSize='2.5rem' />,
    text: 'Phone',
    url: 'tel:+21624967414',
  },
  {
    id: 2,
    icon: (
      <AiFillInstagram className='instagram' color='var(--clr-primary-5)' fontSize='2.5rem' />
    ),
    text: 'Instagram',
    url: 'https://www.instagram.com/daristatn?igsh=MTA1anAya3ZqcnFrdg==',
  },
  {
    id: 3,
    icon: (
      <AiFillFacebook
        className='facebook'
        color='var(--clr-primary-5)'
        fontSize='2.5rem'
      />
    ),
    text: 'Facebook',
    url: 'https://www.facebook.com/daristaTN/',
  },
];

export const contactInfo = {
  phone: '+216 24 967 414',
  email: 'contact@darista.tn',
  phoneLink: 'tel:+21624967414',
  emailLink: 'mailto:contact@darista.tn',
};

export const footerLinks = [
  {
    id: 1,
    text: 'Home',
    url: '/',
  },
  {
    id: 2,
    text: 'About',
    url: '/about',
  },
  {
    id: 3,
    text: 'Products',
    url: '/products',
  },
  {
    id: 4,
    text: 'Orders',
    url: '/orders',
  },
];

export const services = [
  {
    id: 1,
    icon: <GiCompass />,
    title: 'User-friendly Website and Mobile App:',
    text: 'Our intuitive platform offers a seamless shopping experience for your customers across multiple devices.',
  },
  {
    id: 2,
    icon: <GiDiamondHard />,
    title: 'Customized Online Store:',
    text: 'Create a unique and visually stunning online store that represents your brand and products.',
  },
  {
    id: 3,
    icon: <GiStabbedNote />,
    title: 'Payment Method:',
    text: `We provide convenient Cash on Delivery payment and home delivery options for a seamless shopping experience.`,
  },
];

const domain = process.env.REACT_APP_BACKEND_HOST;
export const products_url = `${domain}/api/products`;
export const products_client_url = `${domain}/api/products/client`;
export const single_product_url = `${domain}/api/products/`;
export const create_order_url = `${domain}/api/orders/new`;
export const get_order_url = `${domain}/api/orders`;
export const payment_url = `${domain}/api/payment/create-payment-intent`;
export const upload_url = `${domain}/api/upload/`;
export const categories_url = `${domain}/api/categories`;
export const hero_images_url = `${domain}/api/hero-images`;
export const reviews_url = `${domain}/api/products/client/reviews`;
export const platform_reviews_url = `${domain}/api/platform-reviews`;
export const settings_url = `${domain}/api/settings`;
export const search_url = `${domain}/api/search`;
export const search_suggest_url = `${domain}/api/search/suggest`;
export const default_profile_image =
  'https://icon-library.com/images/anonymous-avatar-icon/anonymous-avatar-icon-25.jpg';
